import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getProductbyguid } from "../../services/ProductServices";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/slices/cartSlice";
import toast from "react-hot-toast";
import { addProductToUserCart } from "../../services/cartService";
import { addToWishlist } from "../../redux/slices/wishlistSlice";
import { addProductToUserWishlist } from "../../services/WishlistService";

const ProductDetail = () => {
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1);
  const { guid } = useParams();
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userId = useSelector((state) => state.auth.userId);
  const isLoggedIn = useSelector((state) => state.auth?.isLoggedIn);

  const cartItems = useSelector((state) => (isLoggedIn ? state.cart.userCart : ""|| []));
  const wishlistItems = useSelector((state) => (isLoggedIn ? state.wishlist.userWishlist : state.wishlist.wishlistItems));
  useEffect(() => {
    const fetchProductByGuid = async () => {
      try {
        const product = await getProductbyguid(guid);
        console.log("rr", product[0])
        setProduct(product[0]);
      } catch (err) {
        setError(err.message)
      } finally {
        setLoading(false);
      }
    };

    fetchProductByGuid();
  }, [guid]);


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  const handleAddToCart = async () => {
   
    if (!userId) {
      dispatch(addToCart({ item: product, isGuest: true }));
     // console.log("object", product)
      toast.success(`${product.name} added to cart!`)
      return;
    };
    try {
      const cartData = {
        id: product.id,
        guid: product.guid || "",
        version: 0,
        isDeleted: false,
        createdUser: userId,
        createdDate: new Date().toISOString(),
        updatedUser: userId,
        updatedDate: new Date().toISOString(),
        prodGuId: product.guid,
        quantity: 1,
        shortName: product.name || "Unnamed Product",
        retailRate: product.retailRate ?? 0,
      };
//console.log("object",cartData)
      await addProductToUserCart(cartData);
      dispatch(addToCart({ item: product, isGuest: false }));
      toast.success(`${product.name} added to cart!`);
    } catch (error) {
      toast.error("Failed to add to cart.");
    }
  }

  const handleAddToWishlist = async () => {
    if (!userId) {
      if (wishlistItems.some((wishlistItem) => wishlistItem.id === product.id)) {
        toast.error(`${product.name} is already in wishlist!`);
        return;
      }
      // Guest Wishlist Handling
      dispatch(addToWishlist({ item: product, isGuest: true }));
      toast.success(`${product.name} added to wishlist!`);
      return;
    }

    try {
      // const existingWishlist = await getAllWishlist(userId);
      // if (existingWishlist.some((wishlistItem) => wishlistItem.id === product.id)) {
      //   toast.error(`${product.name} is already in your wishlist!`);
      //   return;
      // }
      const wishlistData = {
        id: product.id,
        guid: product.guid || "",
        version: 0,
        isDeleted: false,
        createdUser: userId,
        createdDate: new Date().toISOString(),
        updatedUser: userId,
        updatedDate: new Date().toISOString(),
        prodGuId: product.guid,
        shortName: product.name || "Unnamed Product",
        retailRate: product.retailRate ?? 0,
      };

      await addProductToUserWishlist(wishlistData);
      dispatch(addToWishlist({ item: product, isGuest: false }));
      toast.success(`${product.name} added to your wishlist!`);
    } catch (error) {
      toast.error("Failed to add to wishlist.");
    }

  };


  const handleQuantityChange = (type) => {
    if (type === "minus" && quantity > 1) {
      setQuantity(quantity - 1);
    } else if (type === "plus" && quantity < 100) {
      setQuantity(quantity + 1);
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 50,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: 1500,
    //speed: 2000,
    autoplaySpeed: 2500,
    //cssEase: "linear",


  };
  // const coffeeItems = [
  //   { id: 1, name: "Coffee Capuccino", image: "images/seracoffee-2.jpeg", price: "$5.90" },
  //   { id: 2, name: "Coffee Capuccino", image: "images/seracoffee-2.jpeg", price: "$5.90" },
  //   { id: 3, name: "Coffee Capuccino", image: "images/seracoffee-2.jpeg", price: "$5.90" },
  //   { id: 4, name: "Coffee Capuccino", image: "images/seracoffee-2.jpeg", price: "$5.90" },

  // ];

  const isInCart = cartItems.some((cartItem) => cartItem.id === product.id);
  const isInWishlist = Array.isArray(wishlistItems) && wishlistItems.some((wishlistItem) => wishlistItem.id === product.id);

  return (
    <section className="ftco-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 mb-5 ">
            <div className="item card  border-0 rounded-0">
              <div className="card-body p-0 cardBody">
                <Slider {...settings}>
                  {product?.strProdImage?.split(",").map((imgPath, index) => {

                    return (
                      <div key={index}>
                        <Link href="">
                          <img src={`https://inventory-api.exodusvacations.in/${imgPath.trim().replace(/^wwwroot\//,"")}`}
                           alt={`Product image ${index + 1}`}  
                          className="img-fluid" 
                          //  height={520}
                          //  width={550}
                           />
                        </Link>
                      </div>
                    )

                  })
                  }
                </Slider>
              </div>
            </div>
            {/* <a href="images/menu-2.jpg" className="image-popup">
              <img
                src="/images/menu-2.jpg"
                className="img-fluid"
                alt="Creamy Latte Coffee"
              />
            </a> */}
          </div>
          <div className="col-lg-6 product-details pl-md-5 text-left ">
            <h3 className="text-white">{product?.name}</h3>
            <p className="price">
              <span>₹ {product?.retailRate}</span>
            </p>

            <p className="text-light">

          {product?.shortDescription}
            </p>

            <div className="row mt-4">
              <div className="col-md-6">
                <div className="form-group d-flex">
                  {/* <div className="select-wrap">
                    <div className="icon">
                      <span className="ion-ios-arrow-down"></span>
                    </div>
                    <select className="form-control">
                      <option>100gm</option>
                      <option>200gm</option>
                      <option>500gm</option>
                      <option>1000gm</option>
                    </select>
                  </div> */}
                </div>
              </div>
              <div className="w-100">
                <div className="input-group col-md-6 d-flex mb-3 p-0">
                  <span className="input-group-btn mr-2">
                    <button
                      type="button"
                      className="quantity-left-minus btn ml-0"
                      onClick={() => handleQuantityChange("minus")}
                    >
                      <i className="icon-minus"></i>
                    </button>
                  </span>
                  <input
                    type="text"
                    className="form-control input-number"
                    value={quantity}
                    readOnly
                  />
                  <span className="input-group-btn ml-2">
                    <button
                      type="button"
                      className="quantity-right-plus btn"
                      onClick={() => handleQuantityChange("plus")}
                    >
                      <i className="icon-plus"></i>
                    </button>
                  </span>
                </div>
              </div>
              </div>
            <div className="row">
              <div className="col-lg-6">
                <p>
                  {isInCart ? (
                    <Link to="/cart"  className="btn btn-primary w-100 py-3 px-5 rounded-0">Go to cart</Link>
                  ) : (
                    <a onClick={() => handleAddToCart()}
                    className="btn btn-primary w-100 py-3 px-5 rounded-0">
                      Add to Cart
                    </a>
                  )}



                </p>
                {/* <a href="/" className="btn btn-primary w-100 py-3 px-5 rounded-0">
                  Add to Cart
                </a> */}
              </div>
              <div className="col-lg-6">
                 {/* <button
                                              className={`wishlisticon ${isInWishlist ? "wishlisted" : ""}`}
                                              onClick={() => handleAddToWishlist()}
                                            > */}
                                              {isInWishlist ?  <a href="/wishlist" className="btn btn-primary w-100 py-3 px-5 rounded-0">
                  Added to wishlist
                </a> :   <a  className="btn btn-primary w-100 py-3 px-5 rounded-0"  onClick={() => handleAddToWishlist()}>
                  Add to wishlist
                </a>}
                                            {/* </button> */}
                {/* <a href="/" className="btn btn-primary w-100 py-3 px-5 rounded-0">
                  Add to wishlist
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
















      {/* 
      <div className="item card  border-0 rounded-0">
        <div className="card-body p-0 cardBody">
          <Slider {...settings}>
            {coffeeItems?.map((images, index) => {
           
                return (
                  <div key={index}>
                    <Link href="">
                    <img src="/images/menu-4.jpg" alt="" className="image-size img-fluid" />
                    </Link>
                  </div>
                )
            
            })
            }
          </Slider>
        </div>
      </div> */}
    </section>
  );
};

export default ProductDetail;
